import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Chip from '../../../CoreWrappers/Chip';
import Dropdown from '../../../CoreWrappers/Dropdown';

export const MAROON = 'maroon';
export const PURPLE = 'purple';

const UserList = ({triggerVariant, list, singleLabel, pluralLabel, customItemRender, counterState}) => {
	const count = list?.length || 0;
	const countLabel = count === 1 ? singleLabel : pluralLabel;
	const triggerText = `${count} ${countLabel}`;

	const renderTrigger = (triggerAction) => {
		const props = {
			onClick: triggerAction, //TODO: call API here for entityAdmin ?
			title: triggerText,
			variant: triggerVariant
		};

		return <Chip {...props}>{triggerText}</Chip>;
	};

	const mapItems = (item, index) => {
		const obj = {
			id: index,
			label: item,
			type: 'container'
		};
		if (customItemRender) obj.customRender = customItemRender;
		return obj;
	};

	const props = {
		trigger: renderTrigger(),
		topfix: true,
		items: list.map(mapItems)
	};

	return <Dropdown {...props} />;
};

UserList.propTypes = {
	triggerVariant: PropTypes.oneOf[(MAROON, PURPLE)],
	triggerText: PropTypes.string,
	customItemRender: PropTypes.func
};

UserList.defaultProps = {
	triggerVariant: MAROON,
	triggerText: '',
	customItemRender: null
};

export default UserList;
